// Centralised brand + content constants for the SEED website.
// Keep marketing copy here to make future edits trivial.

export const BRAND = {
  name: "SEED",
  full: "Solar Energy Efficiency Developments Ltd",
  tagline: "The Last Electricity Bill You'll Ever Negotiate.",
  contactEmail: "info@seedev.uk",
  contactPhone: "07771 658 206",
  contactAddress: "Suite 3, 1-3 Warren Court, Park Road, Crowborough, TN6 2QX",
  domain: "seedev.uk",
};

export const LOGOS = {
  linear: "/brand/seed_logo_linear.png",
  stacked: "/brand/seed_logo_stacked.png",
  stackedSvg: "/brand/seed_logo_stacked.svg",
  wordmarkSvg: "/brand/seed_logotype.svg",
};

export const IMAGES = {
  heroCommunity:
    "https://static.prod-images.emergentagent.com/jobs/1a3d70a9-efcc-4398-8377-1c2acfc87f71/images/e69608ce217bc1e5bc7a66cb3b70d128dfc9c985d2b93716263f47e5b336a300.png",
  commercialRoof:
    "https://images.pexels.com/photos/35691079/pexels-photo-35691079.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  schoolsAerial:
    "https://images.pexels.com/photos/9800001/pexels-photo-9800001.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  rugbyClub:
    "https://static.prod-images.emergentagent.com/jobs/1a3d70a9-efcc-4398-8377-1c2acfc87f71/images/b1e84490777c73d09a829628753c1f1a5a6061a156d7e146c62f01512c799b72.png",
  trusteeShield:
    "https://static.prod-images.emergentagent.com/jobs/1a3d70a9-efcc-4398-8377-1c2acfc87f71/images/39686390c4a01785ea3a4e39e5cb199fddfe9a2d03388d8e34a58654c5fe0b61.png",
};

export const NAV_LINKS = [
  { label: "Sports Clubs", to: "/sectors/sports-clubs" },
  { label: "Schools", to: "/sectors/schools" },
  { label: "Farms", to: "/sectors/farms" },
  { label: "Trustee Hub", to: "/trustee-hub" },
  { label: "Case Study", to: "/case-study" },
];

export const ORG_TYPES = [
  "Sports Club",
  "Independent School",
  "State School / Academy",
  "Farm",
  "Charity / Trust",
  "Other",
];

export const BILL_BANDS = [
  "Under £500 / month",
  "£500 – £1,500 / month",
  "£1,500 – £5,000 / month",
  "£5,000 – £15,000 / month",
  "Over £15,000 / month",
];
